/* MenaHub — cookie consent banner + consent-gated personalization.
 *
 * 1. Consent banner (Accept All / Customize / Learn More), EN + AR.
 *    Choice stored in localStorage mh_consent_v1: {essential, analytics, personalization}.
 * 2. When personalization is granted: a random anonymous id (mh_uid cookie)
 *    tracks product/collection/search views to the middleware (api/track.php).
 * 3. Homepage gets a "Picked for you" product row from api/recommendations.php
 *    built from that visitor's own browsing. Hidden until there's enough signal.
 */
(function () {
  'use strict';
  var API = 'https://admin.menahub.com/api';
  var IS_AR = /^\/ar(\/|$)/.test(location.pathname);
  var T = IS_AR ? {
    msg: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا.',
    learn: 'اعرف المزيد',
    accept: 'قبول الكل',
    customize: 'تخصيص',
    save: 'حفظ التفضيلات',
    prefsTitle: 'تفضيلات ملفات تعريف الارتباط',
    essential: 'أساسية (مطلوبة)',
    essentialDesc: 'تسجيل الدخول، السلة، وأمان الموقع.',
    analytics: 'التحليلات',
    analyticsDesc: 'تساعدنا على فهم استخدام الموقع وتحسينه.',
    personalization: 'التخصيص',
    personalizationDesc: 'عروض ومنتجات مقترحة حسب اهتماماتك.',
    picked: 'مختارات لك'
  } : {
    msg: 'We use cookies to improve your experience on our website.',
    learn: 'Learn More',
    accept: 'ACCEPT ALL',
    customize: 'CUSTOMIZE',
    save: 'Save preferences',
    prefsTitle: 'Cookie preferences',
    essential: 'Essential (required)',
    essentialDesc: 'Login, cart and site security.',
    analytics: 'Analytics',
    analyticsDesc: 'Helps us understand and improve the site.',
    personalization: 'Personalization',
    personalizationDesc: 'Offers and product picks based on your interests.',
    picked: 'Picked for you'
  };

  function getConsent() {
    try { return JSON.parse(localStorage.getItem('mh_consent_v1') || 'null'); } catch (e) { return null; }
  }
  function setConsent(c) {
    c.essential = true; c.t = Date.now();
    try { localStorage.setItem('mh_consent_v1', JSON.stringify(c)); } catch (e) {}
    document.cookie = 'mh_consent=' + (c.personalization ? 'p' : '') + (c.analytics ? 'a' : '') + 'e; path=/; max-age=31536000; SameSite=Lax';
    // Mirror the choice to the middleware so admin can see who consented
    // (admin/consents.php → Cookies tab). Fire-and-forget.
    try {
      var mm = document.cookie.match(/(?:^|; )mh_market=([^;]*)/);
      var headers = { 'Content-Type': 'application/json' };
      var tok = '';
      try { tok = localStorage.getItem('mh_token') || ''; } catch (e2) {}
      if (tok) headers.Authorization = 'Bearer ' + tok;
      fetch(API + '/consent_log.php', {
        method: 'POST', headers: headers,
        body: JSON.stringify({
          uid: uid(),
          analytics: c.analytics ? 1 : 0,
          personalization: c.personalization ? 1 : 0,
          market: (mm && decodeURIComponent(mm[1]) === 'sa') ? 'sa' : 'qa',
          lang: IS_AR ? 'ar' : 'en'
        })
      }).catch(function () {});
    } catch (e3) {}
  }

  /* ── Banner ─────────────────────────────────────────────────────── */
  function cookieIcon() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z');
    path.setAttribute('stroke', '#fff'); path.setAttribute('stroke-width', '1.8'); path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);
    [[8.5, 10.5], [12, 15.5], [15.5, 11]].forEach(function (c) {
      var dot = document.createElementNS(NS, 'circle');
      dot.setAttribute('cx', c[0]); dot.setAttribute('cy', c[1]); dot.setAttribute('r', '0.9'); dot.setAttribute('fill', '#fff');
      svg.appendChild(dot);
    });
    return svg;
  }

  function showBanner() {
    var bar = document.createElement('div');
    bar.id = 'mh-consent-bar';
    bar.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');
    // Compact pill, centered — brand navy with a slide-up entrance.
    bar.style.cssText = 'position:fixed;left:50%;bottom:16px;z-index:99999;'
      + 'display:flex;align-items:center;gap:12px;flex-wrap:nowrap;'
      + 'max-width:min(760px,94vw);padding:9px 10px;'
      + 'background-color:#0b3350;'
      + 'border:1px solid rgba(255,255,255,.14);border-radius:999px;'
      + 'box-shadow:0 12px 34px rgba(2,6,23,.35);'
      + 'font-size:13px;color:#e2e8f0;'
      + 'transform:translate(-50%,80px);opacity:0;transition:transform .45s cubic-bezier(.16,1,.3,1),opacity .45s;';
    var ic = document.createElement('span');
    ic.style.cssText = 'flex:none;width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#f5a05a,#e0552c);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 1px 0 rgba(255,255,255,.35);';
    ic.appendChild(cookieIcon());
    var txtWrap = document.createElement('span');
    txtWrap.style.cssText = 'min-width:0;line-height:1.3;';
    var txt = document.createElement('span'); txt.textContent = T.msg + ' ';
    var learn = document.createElement('a');
    learn.href = (IS_AR ? '/ar' : '') + '/pages/privacy-policy';
    learn.textContent = T.learn;
    learn.style.cssText = 'color:#7dd3fc;font-weight:700;text-decoration:underline;text-underline-offset:2px;white-space:nowrap;';
    txtWrap.appendChild(txt); txtWrap.appendChild(learn);
    function btn(label, solid) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = label;
      b.style.cssText = 'flex:none;padding:9px 16px;border-radius:999px;font-weight:800;font-size:12px;letter-spacing:.3px;cursor:pointer;transition:transform .15s;white-space:nowrap;'
        + (solid ? 'background:linear-gradient(135deg,#f5a05a,#e0552c);border:0;color:#fff;box-shadow:0 3px 10px rgba(224,85,44,.4);'
                 : 'background:transparent;border:1px solid rgba(255,255,255,.35);color:#e2e8f0;');
      b.addEventListener('mouseenter', function () { b.style.transform = 'scale(1.05)'; });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
      return b;
    }
    var acceptB = btn(T.accept, true);
    var custB = btn(T.customize, false);
    acceptB.addEventListener('click', function () {
      setConsent({ analytics: true, personalization: true });
      bar.style.transform = 'translate(-50%,80px)'; bar.style.opacity = '0';
      setTimeout(function () { bar.remove(); }, 400);
      startPersonalization();
    });
    custB.addEventListener('click', function () { bar.remove(); showPrefs(); });

    if (window.innerWidth < 640) {
      // Mobile: full-width rounded card docked above the bottom nav —
      // icon + text on one row, two equal buttons below.
      bar.style.flexDirection = 'column';
      bar.style.alignItems = 'stretch';
      bar.style.gap = '12px';
      bar.style.width = '94vw';
      bar.style.maxWidth = '94vw';
      bar.style.borderRadius = '16px';
      bar.style.padding = '14px';
      var mobNav = document.querySelector('.mh-bottom-nav, .mobile-bottom-nav, [class*="bottom-nav"]');
      bar.style.bottom = (mobNav && mobNav.offsetHeight ? mobNav.offsetHeight + 10 : 12) + 'px';
      var topRow = document.createElement('div');
      topRow.style.cssText = 'display:flex;align-items:flex-start;gap:10px;';
      ic.style.width = '30px'; ic.style.height = '30px';
      txtWrap.style.cssText = 'min-width:0;line-height:1.45;font-size:13px;';
      topRow.appendChild(ic); topRow.appendChild(txtWrap);
      var btnRow = document.createElement('div');
      btnRow.style.cssText = 'display:flex;gap:10px;';
      acceptB.style.flex = '1'; acceptB.style.padding = '12px 10px';
      custB.style.flex = '1'; custB.style.padding = '12px 10px';
      btnRow.appendChild(acceptB); btnRow.appendChild(custB);
      bar.appendChild(topRow); bar.appendChild(btnRow);
    } else {
      bar.appendChild(ic); bar.appendChild(txtWrap); bar.appendChild(acceptB); bar.appendChild(custB);
    }
    document.body.appendChild(bar);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { bar.style.transform = 'translate(-50%,0)'; bar.style.opacity = '1'; });
    });
  }

  function showPrefs() {
    var ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;z-index:100000;background:rgba(15,23,42,.5);display:flex;align-items:center;justify-content:center;padding:16px;';
    var box = document.createElement('div');
    box.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');
    box.style.cssText = 'background:#fff;border-radius:16px;max-width:440px;width:100%;padding:22px;box-shadow:0 20px 60px rgba(15,23,42,.3);font-size:14px;color:#334155;';
    var h = document.createElement('h3'); h.textContent = T.prefsTitle;
    h.style.cssText = 'margin:0 0 14px;font-size:17px;font-weight:800;color:#0f172a;';
    box.appendChild(h);
    function row(title, desc, checked, locked) {
      var r = document.createElement('label');
      r.style.cssText = 'display:flex;align-items:flex-start;gap:10px;padding:10px 0;border-top:1px solid #f1f5f9;cursor:' + (locked ? 'default' : 'pointer') + ';';
      var cb = document.createElement('input');
      cb.type = 'checkbox'; cb.checked = checked; cb.disabled = !!locked;
      cb.style.cssText = 'margin-top:3px;width:16px;height:16px;accent-color:#e2741f;';
      var d = document.createElement('div');
      var t1 = document.createElement('div'); t1.textContent = title; t1.style.fontWeight = '700';
      var t2 = document.createElement('div'); t2.textContent = desc; t2.style.cssText = 'font-size:12.5px;color:#64748b;';
      d.appendChild(t1); d.appendChild(t2);
      r.appendChild(cb); r.appendChild(d);
      box.appendChild(r);
      return cb;
    }
    row(T.essential, T.essentialDesc, true, true);
    var cbA = row(T.analytics, T.analyticsDesc, true, false);
    var cbP = row(T.personalization, T.personalizationDesc, true, false);
    var save = document.createElement('button');
    save.type = 'button'; save.textContent = T.save;
    save.style.cssText = 'margin-top:16px;width:100%;padding:12px;border-radius:10px;border:0;background:#e2741f;color:#fff;font-weight:800;cursor:pointer;';
    save.addEventListener('click', function () {
      setConsent({ analytics: cbA.checked, personalization: cbP.checked });
      ov.remove();
      startPersonalization();
    });
    box.appendChild(save);
    ov.appendChild(box);
    document.body.appendChild(ov);
  }

  /* ── Tracking (personalization consent only) ────────────────────── */
  function uid() {
    var m = document.cookie.match(/(?:^|; )mh_uid=([^;]+)/);
    if (m) return m[1];
    var id = 'mh_' + Array.from(crypto.getRandomValues(new Uint8Array(12))).map(function (b) { return (b % 36).toString(36); }).join('');
    document.cookie = 'mh_uid=' + id + '; path=/; max-age=31536000; SameSite=Lax';
    return id;
  }

  function trackPageView() {
    var p = location.pathname.replace(/^\/ar(?=\/)/, '');
    var ev = null;
    var mProd = p.match(/^\/products\/([^\/?#]+)/);
    var mColl = p.match(/^\/collections\/([^\/?#]+)/);
    if (mProd) ev = { t: 'product', v: decodeURIComponent(mProd[1]) };
    else if (mColl && mColl[1] !== 'all') ev = { t: 'collection', v: decodeURIComponent(mColl[1]) };
    else if (p === '/search') {
      var q = new URLSearchParams(location.search).get('q');
      if (q) ev = { t: 'search', v: q.slice(0, 120) };
    }
    if (!ev) return;
    var payload = JSON.stringify({ uid: uid(), events: [ev] });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/track.php', new Blob([payload], { type: 'application/json' }));
      else fetch(API + '/track.php', { method: 'POST', body: payload, keepalive: true });
    } catch (e) {}
  }

  /* ── "Picked for you" homepage row ──────────────────────────────── */
  function money(v) {
    return 'QAR ' + Number(v).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function offerCard(offer) {
    var a = document.createElement('a');
    a.href = offer.link || '#';
    a.style.cssText = 'flex:0 0 200px;border-radius:14px;overflow:hidden;text-decoration:none;color:#fff;background:linear-gradient(135deg,#f5a05a,#e0552c);display:flex;flex-direction:column;justify-content:center;padding:16px;box-shadow:0 6px 18px rgba(224,85,44,.3);';
    var t = document.createElement('div');
    t.textContent = offer.title || '';
    t.style.cssText = 'font-weight:800;font-size:15px;line-height:1.35;';
    a.appendChild(t);
    if (offer.subtitle) {
      var s = document.createElement('div');
      s.textContent = offer.subtitle;
      s.style.cssText = 'font-size:12px;opacity:.92;margin-top:6px;';
      a.appendChild(s);
    }
    var cta = document.createElement('div');
    cta.textContent = IS_AR ? 'تسوق الآن ←' : 'Shop now →';
    cta.style.cssText = 'font-size:12px;font-weight:800;margin-top:10px;';
    a.appendChild(cta);
    return a;
  }

  /* Legacy simple card — only used as a per-product fallback when the
     real product-card fetch (/products/<handle>?view=mhcard) fails. */
  function simpleCard(p) {
    var a = document.createElement('a');
    a.href = p.url;
    a.style.cssText = 'display:block;width:100%;height:100%;background:#fff;border:1px solid #edf0f4;border-radius:14px;overflow:hidden;text-decoration:none;color:#1e293b;box-shadow:0 1px 2px rgba(2,6,23,.04);';
    var imw = document.createElement('div');
    imw.style.cssText = 'width:100%;height:150px;background:#f6f7f9;';
    var im = document.createElement('img');
    im.src = p.image; im.alt = p.title; im.loading = 'lazy';
    im.style.cssText = 'width:100%;height:100%;object-fit:contain;';
    imw.appendChild(im);
    var tt = document.createElement('div');
    tt.textContent = p.title;
    tt.style.cssText = 'font-size:12px;font-weight:600;line-height:1.35;padding:8px 10px 2px;height:42px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;';
    var pr = document.createElement('div');
    pr.style.cssText = 'padding:2px 10px 10px;font-weight:800;font-size:13.5px;color:#0f172a;';
    pr.textContent = money(p.price);
    if (p.compare && p.compare > p.price) {
      var cmp = document.createElement('span');
      cmp.textContent = ' ' + money(p.compare);
      cmp.style.cssText = 'color:#94a3b8;text-decoration:line-through;font-weight:500;font-size:11px;';
      pr.appendChild(cmp);
    }
    a.appendChild(imw); a.appendChild(tt); a.appendChild(pr);
    return a;
  }

  /* Real homepage card per product handle — fetched from the alternate
     template /products/<handle>?view=mhcard (product-card-only.liquid) and
     cached in sessionStorage so repeat homepage visits render instantly. */
  function cardCacheKey(handle) { return 'mh:pcp:' + (IS_AR ? 'ar' : 'en') + ':' + handle; }
  function extractCard(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-cards-only] .cards-only-cell');
    } catch (e) { return null; }
  }
  function fetchCard(handle) {
    try {
      var raw = sessionStorage.getItem(cardCacheKey(handle));
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.h && (Date.now() - o.t) < 30 * 60 * 1000) {
          var hitNode = extractCard(o.h);
          if (hitNode) return Promise.resolve(hitNode);
        }
      }
    } catch (e) {}
    var url = (IS_AR ? '/ar' : '') + '/products/' + encodeURIComponent(handle) + '?view=mhcard';
    return fetch(url, { credentials: IS_AR ? 'include' : 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var node = extractCard(html);
        if (!node) throw new Error('no card');
        try { sessionStorage.setItem(cardCacheKey(handle), JSON.stringify({ t: Date.now(), h: html })); } catch (e) {}
        return node;
      });
  }

  /* Carousel arrows — same behaviour as the homepage product rows:
     RTL-aware bounds, eased scroll, disabled at the edges. */
  function carBounds(track) {
    var span = track.scrollWidth - track.clientWidth;
    return IS_AR ? { min: -span, max: 0 } : { min: 0, max: span };
  }
  function carScroll(track, dir) {
    var b = carBounds(track);
    var step = Math.round(track.clientWidth * 0.85) * (IS_AR ? -dir : dir);
    var target = Math.max(b.min, Math.min(b.max, track.scrollLeft + step));
    var startL = track.scrollLeft, dist = target - startL, t0 = null;
    if (!dist) return;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / 350, 1);
      track.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function carSync(track, prevBtn, nextBtn) {
    var b = carBounds(track), sl = track.scrollLeft;
    var atStart = IS_AR ? sl >= b.max - 1 : sl <= b.min + 1;
    var atEnd = IS_AR ? sl <= b.min + 1 : sl >= b.max - 1;
    prevBtn.toggleAttribute('disabled', atStart);
    nextBtn.toggleAttribute('disabled', atEnd);
  }
  function carArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
    b.style.cssText = 'position:absolute;top:50%;transform:translateY(-50%);z-index:5;'
      + (dir < 0 ? 'left:-14px;' : 'right:-14px;')
      + 'width:40px;height:40px;border-radius:50%;background:#fff;border:1px solid #e5e7eb;'
      + 'box-shadow:0 4px 12px rgba(0,0,0,.12);cursor:pointer;display:flex;align-items:center;justify-content:center;color:#1f2226;transition:background .15s,opacity .15s;';
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    var pl = document.createElementNS(NS, 'polyline');
    pl.setAttribute('points', dir < 0 ? '15 18 9 12 15 6' : '9 6 15 12 9 18');
    svg.appendChild(pl);
    b.appendChild(svg);
    b.addEventListener('mouseenter', function () { b.style.background = '#f5f5f5'; });
    b.addEventListener('mouseleave', function () { b.style.background = '#fff'; });
    return b;
  }

  function renderPicked(products, offer, viewAllUrl) {
    if (!products || products.length < 4) return;
    var root = document.querySelector('[data-mh-dynamic-root]');
    if (!root || document.getElementById('mh-picked')) return;
    var sec = document.createElement('section');
    sec.id = 'mh-picked';
    sec.setAttribute('dir', IS_AR ? 'rtl' : 'ltr');
    sec.style.cssText = 'max-width:1430px;margin:6px auto 18px;padding:0 16px;';

    // Heading row: title left, "View All" right (mirrors .mh-dyn-viewall).
    var head = document.createElement('div');
    head.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 12px;';
    var h = document.createElement('h2');
    h.textContent = T.picked;
    h.style.cssText = 'font-size:20px;font-weight:800;color:#0f172a;margin:0;';
    head.appendChild(h);
    var va = document.createElement('a');
    va.href = viewAllUrl || ((IS_AR ? '/ar' : '') + '/collections/all');
    va.appendChild(document.createTextNode(IS_AR ? 'عرض الكل ' : 'View All '));
    var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chev.setAttribute('width', '14'); chev.setAttribute('height', '14');
    chev.setAttribute('viewBox', '0 0 24 24'); chev.setAttribute('fill', 'none');
    chev.setAttribute('stroke', 'currentColor'); chev.setAttribute('stroke-width', '2.5');
    var pl = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    pl.setAttribute('points', IS_AR ? '15 18 9 12 15 6' : '9 6 15 12 9 18');
    chev.appendChild(pl);
    va.appendChild(chev);
    va.style.cssText = 'display:inline-flex;align-items:center;gap:4px;color:#1f2226;text-decoration:none;font-weight:600;font-size:13px;letter-spacing:.5px;padding:8px 12px;border-radius:8px;white-space:nowrap;';
    va.addEventListener('mouseenter', function () { va.style.background = '#f5f5f5'; });
    va.addEventListener('mouseleave', function () { va.style.background = 'transparent'; });
    head.appendChild(va);

    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative;';
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:12px;overflow-x:auto;scrollbar-width:none;padding-bottom:8px;-webkit-overflow-scrolling:touch;align-items:stretch;';
    var prevB = carArrow(-1);
    var nextB = carArrow(1);
    prevB.addEventListener('click', function () { carScroll(row, -1); });
    nextB.addEventListener('click', function () { carScroll(row, 1); });
    function syncArrows() { carSync(row, prevB, nextB); }
    row.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows, { passive: true });
    wrap.appendChild(prevB); wrap.appendChild(row); wrap.appendChild(nextB);
    if (offer && offer.title) row.appendChild(offerCard(offer));

    var cellW = (window.innerWidth || 1200) < 768 ? '165px' : '205px';
    products.slice(0, 14).forEach(function (p) {
      var cell = document.createElement('div');
      cell.style.cssText = 'flex:0 0 ' + cellW + ';min-width:0;';
      // Skeleton shimmer while the real card streams in — no blank gap.
      var skel = document.createElement('div');
      skel.style.cssText = 'width:100%;height:330px;border-radius:14px;background:linear-gradient(90deg,#f1f3f6 25%,#e9edf2 37%,#f1f3f6 63%);background-size:400% 100%;animation:mhPickedShimmer 1.2s ease infinite;';
      cell.appendChild(skel);
      row.appendChild(cell);
      fetchCard(p.handle).then(function (node) {
        // Empty card (product unpublished / out of stock / hidden) → drop the
        // cell entirely instead of leaving a blank gap in the row.
        if (!node || !node.querySelector('.mh-card')) {
          if (cell.parentNode) cell.parentNode.removeChild(cell);
          syncArrows();
          return;
        }
        cell.textContent = '';
        while (node.firstChild) cell.appendChild(node.firstChild);
        try {
          window.dispatchEvent(new CustomEvent('mh:product-cards-injected', { detail: { container: cell } }));
        } catch (e) {}
        syncArrows();
      }).catch(function () {
        cell.textContent = '';
        cell.appendChild(simpleCard(p));
        syncArrows();
      });
    });
    syncArrows();
    if (!document.getElementById('mh-picked-css')) {
      var st = document.createElement('style');
      st.id = 'mh-picked-css';
      st.textContent = '@keyframes mhPickedShimmer{0%{background-position:100% 0}100%{background-position:0 0}}' +
        '#mh-picked .mh-card{height:100%}';
      document.head.appendChild(st);
    }
    sec.appendChild(head); sec.appendChild(wrap);
    // Placement: below the hero carousel, above "More reasons to shop".
    // The dynamic renderer builds sections asynchronously, so retry briefly
    // until the anchor section exists; fall back to the top of the page.
    var attempts = 0;
    (function place() {
      var target = Array.prototype.find.call(
        document.querySelectorAll('.mh-dyn-section'),
        function (s) { return /more reasons to shop|أسباب إضافية للتسوّق|أسباب إضافية/i.test((s.textContent || '').slice(0, 300)); }
      );
      if (target && target.parentNode) {
        target.parentNode.insertBefore(sec, target);
      } else if (attempts++ < 20) {
        setTimeout(place, 500);
        return;
      } else {
        root.parentNode.insertBefore(sec, root); // fallback: above the dynamic sections
      }
    })();
  }

  function loadPicked() {
    var onHome = location.pathname === '/' || location.pathname === '/ar' || location.pathname === '/ar/';
    if (!onHome) return;
    fetch(API + '/recommendations.php?uid=' + encodeURIComponent(uid()) + (IS_AR ? '&lang=ar' : ''), { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) renderPicked(d.products, d.offer, d.view_all); })
      .catch(function () {});
  }

  function startPersonalization() {
    var c = getConsent();
    if (!c || !c.personalization) return;
    trackPageView();
    loadPicked();
  }

  /* Admin gate: backend_settings → Cookies Consent Banner card decides
   * whether the banner shows at all, per market (qa/sa) and language.
   * Config rides in quickbuy_config (cached in localStorage mh_qb_cfg by
   * mh-quickbuy.js). Missing/unreadable config = banner ON (safe default). */
  function cookiesAllowed(cfg) {
    var k = cfg && cfg.cookies;
    if (!k) return true;
    if (!k.enabled) return false;
    var m = document.cookie.match(/(?:^|; )mh_market=([^;]*)/);
    var mkt = (m && decodeURIComponent(m[1]) === 'sa') ? 'sa' : 'qa';
    if ((k.markets || []).indexOf(mkt) === -1) return false;
    if ((k.langs || []).indexOf(IS_AR ? 'ar' : 'en') === -1) return false;
    return true;
  }
  function withCookiesGate(fn) {
    // Only trust a FRESH cache (<60s) — admin toggles must apply instantly,
    // and the save purges the API cache, so a live fetch reflects it at once.
    var cached = null;
    try {
      var raw = localStorage.getItem('mh_qb_cfg');
      if (raw) {
        var o = JSON.parse(raw) || {};
        if (o.c && (Date.now() - (o.t || 0)) < 60000) cached = o.c;
      }
    } catch (e) {}
    if (cached) { fn(cookiesAllowed(cached)); return; }
    fetch(API + '/quickbuy_config.php', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) { fn(cookiesAllowed(d && d.success ? d.config : null)); })
      .catch(function () { fn(true); });
  }

  function boot() {
    var c = getConsent();
    if (!c) withCookiesGate(function (ok) { if (ok) showBanner(); });
    else startPersonalization();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
